import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';

const RestRelatorioAvancadoPost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = (Arr_.dest ?? '')
    .toString()
    .replace(/[\s\u200B-\u200D\uFEFF\u0000]/g, '')
    .trim();

  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  $.ajaxSetup({headers: {Authorization: 'Bearer ' + token}});

  // Helper: monta dataPost_, chama backend e resolve com base64_decode(data)
  const callBackend = (dataPost) => {
    return new Promise(function (resolve, reject) {
      const dataPost_ = [
        base64_encode(emp),
        base64_encode(uid),
        base64_encode(JSON.stringify(dataPost)),
      ];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Post',
          dataType: 'json',
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode(caminho),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: function (data) {
            resolve([200, base64_decode(data)]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err + ' Server Error'}]);
      }
    });
  };

  switch (caminho) {
    // Retorna filtros disponíveis do catálogo para o menu relatorio-avancado (menu_item_id=17)
    // dataPost: {}
    case 'avancadoGetFiltros':
      return callBackend(JSON.parse(config.data).dataPost);

    // Retorna colunas disponíveis para a origem informada (1=nfe, 2=cte, 3=nfse)
    // dataPost: { origem: number }
    case 'avancadoGetColunas':
      return callBackend(JSON.parse(config.data).dataPost);

    // Retorna modelos salvos para o menu 'relatorio-avancado'
    // dataPost: { menu: string }
    case 'avancadoGetModelos':
      return callBackend(JSON.parse(config.data).dataPost);

    // Salva ou atualiza um modelo personalizado
    // dataPost: { menu: string, nome: string, config: string (JSON) }
    case 'avancadoSalvarModelo':
      return callBackend(JSON.parse(config.data).dataPost);

    // Marca um modelo antigo como migrado (migrou = true)
    // dataPost: { record_id: number }
    case 'avancadoMarcarMigrado':
      return callBackend(JSON.parse(config.data).dataPost);

    // Deleta um modelo salvo
    // dataPost: { record_id: number }
    case 'avancadoDeletarModelo':
      return callBackend(JSON.parse(config.data).dataPost);

    // Define um modelo como padrão do usuário (desmarca os demais)
    // dataPost: { record_id: number, menu: string }
    case 'avancadoDefinirPadrao':
      return callBackend(JSON.parse(config.data).dataPost);

    // Atualiza config (e opcionalmente nome) de um modelo existente
    // dataPost: { record_id: number, config: string (JSON), nome?: string }
    case 'avancadoAtualizarModelo':
      return callBackend(JSON.parse(config.data).dataPost);

    // Enfileira o relatório em historico_downloads (tipo=5, status=1)
    // dataPost: { filtros: object, config: string (JSON), descricao: string }
    case 'avancadoSolicitarRelatorio':
      return callBackend(JSON.parse(config.data).dataPost);

    default:
      return Promise.reject([400, {message: `avancado: caso desconhecido '${caminho}'`}]);
  }
};

export {RestRelatorioAvancadoPost};
